import React, { useState } from "react";
import { Tooltip, IconButton, Button } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";
import { copyToClipboard } from "../../../utils/clipboard";

function CopyButton({
  text,
  label = "Copiar erro",
  variant = "icon", // "icon" | "button" | "outlined" | "contained"
  size = "small",
  color = "inherit",
  sx = {},
}) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async (e) => {
    if (e && e.stopPropagation) e.stopPropagation();
    const success = await copyToClipboard(text);
    if (success) {
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    }
  };

  if (variant === "button" || variant === "outlined" || variant === "contained") {
    return (
      <Button
        size={size}
        variant={variant === "button" ? "outlined" : variant}
        color={copied ? "success" : color}
        startIcon={
          copied ? <CheckIcon fontSize="small" /> : <ContentCopyIcon fontSize="small" />
        }
        onClick={handleCopy}
        sx={{
          textTransform: "none",
          userSelect: "none",
          ...sx,
        }}
      >
        {copied ? "Copiado!" : label}
      </Button>
    );
  }

  return (
    <Tooltip title={copied ? "Copiado!" : label} arrow>
      <IconButton
        size={size}
        color={copied ? "success" : color}
        onClick={handleCopy}
        aria-label={copied ? "Copiado!" : label}
        sx={{
          p: 0.5,
          userSelect: "none",
          ...sx,
        }}
      >
        {copied ? (
          <CheckIcon fontSize="small" />
        ) : (
          <ContentCopyIcon fontSize="small" />
        )}
      </IconButton>
    </Tooltip>
  );
}

export default CopyButton;
